import { AppLogo } from "components/AppIcon/AppLogo";
import { useLangContext } from "context/Lang";
import { Link } from "react-router-dom";

export const Footer = () => {
    const { gW } = useLangContext();
    const apkUrl = "/app-release.apk";

    return (
        <footer className="border-t border-primary-600 bg-primary-900 text-primary-50">
            <div className="container mx-auto px-6 py-12">
                <div className="grid gap-8 md:grid-cols-4">
                    {/* 1. Logo + Description + APK Download */}
                    <div className="space-y-4 md:col-span-2">
                        <div className="flex items-center gap-2">
                            <AppLogo />
                        </div>
                        <p className="text-sm text-primary-200 leading-relaxed max-w-md">
                            {gW("footer-description") || "تطبيق طالع (Tale3) - المنصة الرائدة للتنقل الذكي وخدمات التوصيل بكل أمان وسهولة."}
                        </p>
                        
                        {/* Quick APK Download Link */}
                        <a
                            href={apkUrl}
                            download="Tale3.apk"
                            className="inline-flex items-center gap-2 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 text-white px-3 py-2 rounded-md transition shadow-sm"
                        >
                            <svg className="h-4 w-4 fill-current" viewBox="0 0 24 24">
                                <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997 0-.551.4482-.9993.9993-.9993.5519 0 .9997.4483.9997.9993 0 .5511-.4478.9997-.9997.9997zm-11.046 0c-.5511 0-.9993-.4486-.9993-.9997 0-.551.4482-.9993.9993-.9993.5518 0 .9997.4483.9997.9993 0 .5511-.4479.9997-.9997.9997zm11.4045-6.02l1.9973-3.4592c.1256-.2176.0503-.4962-.1673-.6218-.2177-.1256-.4963-.0503-.6219.1673l-2.0233 3.5042c-1.4082-.6423-2.9984-1.0042-4.6663-1.0042-1.6679 0-3.2581.3619-4.6663 1.0042l-2.0233-3.5042c-.1256-.2176-.4042-.2929-.6219-.1673-.2176.1256-.2929.4042-.1673.6218l1.9973 3.4592c-3.1367 1.7061-5.263 4.9082-5.4623 8.6502h22.0003c-.1993-3.742-2.3256-6.9441-5.4623-8.6502z"/>
                            </svg>
                            <span>{gW("download-apk") || "تحميل التطبيق (APK)"}</span>
                        </a>
                    </div>

                    {/* 2. Legal / Quick Links */}
                    <div className="space-y-3">
                        <h3 className="text-sm font-bold text-white uppercase tracking-wider">
                            {gW("legal-links") || "السياسات والشروط"}
                        </h3>
                        <ul className="space-y-2 text-sm text-primary-200">
                            <li>
                                <Link 
                                    to="/privacy-policy" 
                                    className="hover:text-emerald-400 transition-colors"
                                >
                                    {gW("privacy-policy") || "سياسة الخصوصية"}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="mt-8 border-t border-primary-700 pt-8 text-center text-sm text-primary-300">
                    <p>
                        © {new Date().getFullYear()} Tale3 — {gW("rights-reserved") || "جميع الحقوق محفوظة"}
                    </p>
                </div>
            </div>
        </footer>
    );
};